export default "__VITE_ASSET__VNkmJ0Cm__"